/*
 * @Description: 下拉单选
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-18 15:11:16
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-14 18:08:46
 */

import classnames from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Control, Controller } from 'react-hook-form';
import { isMobile } from '../../lib';
import './Select.less';


export interface ISelectProps {
  name: string;
  options: { label: string; value: string | number }[];
  control: Control;
  style?: React.CSSProperties;
  className?: string;
  defaultValue?: string;
  useFastSelect?: boolean;
}

export interface IfieldProps {
  field: {
    value: string;
    onChange: (val: string | number) => void;
  };
}

export const Select = (props: ISelectProps) => {
  const { name, options, control, style = {}, className = '', defaultValue = '', useFastSelect } = props;
  const [optionStyle] = useState<React.CSSProperties>({ width: '-1000px' });
  const btnRef = useRef<HTMLButtonElement | null>(null);
  const [optionsWithFilter, setOptionsWithFilter] = useState(options);
  const [inputValue, setInputValue] = useState<string | number | undefined>();
  const [forcehover, setForceHover] = useState(false);
  const [useFastSelectCanUseDefaultValue, setUseFastSelectCanUseDefaultValue] = useState(true);
  // const [canHover, setCanHover] = useState(true);

  useEffect(() => {
    setOptionsWithFilter(options);
  }, [options]);

  const fastInputHandleChange = useCallback(
    (e) => {
      if (useFastSelectCanUseDefaultValue) {
        setUseFastSelectCanUseDefaultValue(false);
      }

      const newoptions = options.filter(item => item.label.toLowerCase().includes(e.target.value.toLowerCase()));
      setOptionsWithFilter(newoptions);

      setInputValue(e.target.value);
    },
    [options, useFastSelectCanUseDefaultValue],
  );

  const fastInputBlur = useCallback((e, onChange) => {
    setForceHover(false);

    if (!inputValue) {
      onChange(undefined);

      return;
    }

    const canUseFastInputData = options.filter(item => item.label.toLowerCase() === e.target.value.toLowerCase());

    if (canUseFastInputData[0]) {
      onChange(canUseFastInputData[0].value);
      setInputValue(canUseFastInputData[0].label);
    } else {
      onChange(undefined);
      setInputValue('');
      setOptionsWithFilter(options);
    }
  }, [options, inputValue]);

  return (
    <Controller
      name={name}
      control={control}
      render={(fieldProps) => {
        const { value, onChange } = fieldProps;
        const selected = optionsWithFilter.find(v => v.value === value) || { label: value, value };

        return (
          <div className={classnames(['login-v2-select'], className, { canHover: optionsWithFilter.length > 0, forcehover })} style={style}>
            <button
              ref={btnRef}
              type="button"
              className={classnames('select', { 'not-selected': !selected.label })}
              onClick={() => {
                if (isMobile()) {
                  setForceHover(true);
                }
              }}
            >
              {useFastSelect ? (
                <input
                  autoComplete="off"
                  className="input"
                  onChange={fastInputHandleChange}
                  placeholder={defaultValue}
                  value={inputValue || (useFastSelectCanUseDefaultValue && selected.label) || ''}
                  onBlur={e => fastInputBlur(e, onChange)}
                  onFocus={() => setForceHover(true)}
                  // onMouseEnter={() => setCanHover(true)}
                />
              ) : selected.label || defaultValue}
            </button>
            <div className="pad" style={optionStyle} />
            <ul className="options" style={optionStyle}>
              {optionsWithFilter.map(v => (
                <li
                  key={v.value}
                  className={classnames({ option: true, selected: v.value === selected.value })}
                  onMouseDown={() => {
                    onChange(v.value);
                    setInputValue(v.label);
                    setForceHover(false);
                    // setCanHover(false);
                  }}
                >
                  {v.label}
                </li>
              ))}
            </ul>
          </div>
        );
      }}
    />
  );
};
